// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-content {
  position: absolute;
  height: 100%;
  width: 100%;
  padding-bottom: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.no-content ion-spinner {
  width: 50px;
  height: 50px;
}

.content-tree-invisible {
  display: none;
}

.content-tree {
  padding: 0px;
  background: transparent;
}

.mat-nested-tree-node div[role=group] {
  padding-left: 24px;
}

.mat-tree-node {
  min-height: 36px !important;
}

.tree-item {
  width: 100%;
  --color: var(--ion-color-primary);
  --background: transparent;
  --background-hover: var(--ion-color-primary);
  --ripple-color: var(--ion-color-light);
  --border-color: var(--ion-color-medium);
  --color-hover: var(--ion-color-dark);
  --border-style: solid;
  --border-width: 1px;
  --border-radius: 6px 6px 6px 6px;
  --min-height: 30px;
  --inner-border-width: 0px;
  --padding-start: 8px;
  font-size: 20px;
  margin: 0px;
  touch-action: pan-y !important;
}
.tree-item ion-label {
  margin: 0px;
  font-size: 14px;
  padding-left: 10px;
}
.tree-item ion-button {
  --border-width: 1px;
}

.selected-item {
  --background: var(--ion-color-primary);
  color: var(--ion-color-dark-contrast);
  --border-color: var(--ion-color-primary);
  --color-hover: #fff;
}
.selected-item ion-label {
  color: var(--ion-color-dark-contrast);
}

.selected-item:hover {
  --background: var(--ion-color-dark);
}

.root-item {
  --border-width: 1px 1px 1px 0px !important;
  --border-radius: 0px 6px 6px 0px !important;
}

.trailing-icon {
  font-size: 20px;
  --background: var(--ion-background-color);
}`, "",{"version":3,"sources":["webpack://./src/app/shared-components/content-tree/content-tree.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;AAEJ;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,YAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,iCAAA;EACA,yBAAA;EACA,4CAAA;EACA,sCAAA;EACA,uCAAA;EACA,oCAAA;EACA,qBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,WAAA;EACA,8BAAA;AACF;AAAE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AAEJ;AAAE;EACE,mBAAA;AAEJ;;AAEA;EACE,sCAAA;EACA,qCAAA;EACA,wCAAA;EACA,mBAAA;AACF;AAAE;EACE,qCAAA;AAEJ;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,0CAAA;EACA,2CAAA;AACF;;AAEA;EACE,eAAA;EACA,yCAAA;AACF","sourcesContent":[".no-content {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  padding-bottom: 75px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ion-spinner {\n    width: 50px;\n    height: 50px;\n  }\n}\n\n.content-tree-invisible {\n  display: none;\n}\n\n.content-tree {\n  padding: 0px;\n  background: transparent;\n}\n\n.mat-nested-tree-node div[role=\"group\"] {\n  padding-left: 24px;\n}\n\n.mat-tree-node {\n  min-height: 36px !important;\n}\n\n.tree-item {\n  width: 100%;\n  --color: var(--ion-color-primary);\n  --background: transparent;\n  --background-hover: var(--ion-color-primary);\n  --ripple-color: var(--ion-color-light);\n  --border-color: var(--ion-color-medium);\n  --color-hover: var(--ion-color-dark);\n  --border-style: solid;\n  --border-width: 1px;\n  --border-radius: 6px 6px 6px 6px;\n  --min-height: 30px;\n  --inner-border-width: 0px;\n  --padding-start: 8px;\n  font-size: 20px;\n  margin: 0px;\n  touch-action: pan-y !important;\n  ion-label {\n    margin: 0px;\n    font-size: 14px;\n    padding-left: 10px;\n  }\n  ion-button {\n    --border-width: 1px;\n  }\n}\n\n.selected-item {\n  --background: var(--ion-color-primary);\n  color: var(--ion-color-dark-contrast);\n  --border-color: var(--ion-color-primary);\n  --color-hover: #fff;\n  ion-label {\n    color: var(--ion-color-dark-contrast);\n  }\n}\n\n.selected-item:hover {\n  --background: var(--ion-color-dark);\n}\n\n.root-item {\n  --border-width: 1px 1px 1px 0px !important;\n  --border-radius: 0px 6px 6px 0px !important;\n}\n\n.trailing-icon {\n  font-size: 20px;\n  --background: var(--ion-background-color);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
